import {generateMathRandom} from "@/api/drage";
// 扁平化容器配置专用
export function flatObj (arr) {
  if (!arr || arr.length === 0) return []
  return arr.reduce((ar, pic) => {
    if (typeof pic !== 'object') {
      return ar.concat([pic])
    } else if (pic.children && pic.children.length > 0 && !Array.isArray(pic.children[0])) {
      return ar.concat(flatObj(pic.children))
    } else {
      return ar.concat(pic)
    }
  }, [])
}

// 工具条专用
// 生成应用列表配置信息
export function generApplyList (val, nameVal, arr) {
  // 之前的高度 用于记录重置查询的按钮
  const date = {
    i: generateMathRandom(arr, 'i'),
    percentageRX: 0,
    percentageX: 0,
    type: val,
    name: nameVal,
    sort: '' // 手机端排序
  }

  if (val === 'button') {
    date.isLeft = true
    date.isResizable = false
    date.info = {
      // 按钮样式
      buttonStyle: 'one',
      // 选中的绑定功能
      bindingFunction: '',
      // 选中的尺寸
      size: 'small',
      // 选中的图标
      icon: 1,
      // 按钮文本
      text: ''
    }
  } else if (val === 'screen') {
    date.info = {
      style: 1,
      content: '',
      list: []
    }
    date.isResizable = true
    date.isLeft = true
  } else if (val === 'search') {
    date.isResizable = true
    date.isLeft = true
    date.info = {
      style: 1,
      syllable: {},
      status: '',
      showSyllable: false
    }
  } else if (val === 'btnGroup') {
    date.isLeft = true
    date.isResizable = true
    date.info = {
      style: 1,
      content: '',
      list: []
    }
  }
  return date
}

import Axios from 'axios'
export const stringToArrayBufferUpLoad = (blob, that, name = 'configInstrument.txt') => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : ''
    const url = that.$apiurl + '/userfile/upload?accesstoken=' + token
    const file = new File([blob], name, {
      type: 'text/plain'
    })
    const formData = new FormData()
    formData.append('file', file)
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    Axios.post(url, formData, config)
      .then(res => {
        const configUrl = `/userfiles/${res.data}`
        resolve(configUrl)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export const DOORKEY = '0123456789ABCDEF'

export function stringToArrayBuffer (str) {
  var bytes = []
  var len, c
  len = str.length
  for (var i = 0; i < len; i++) {
    c = str.charCodeAt(i)
    if (c >= 0x010000 && c <= 0x10FFFF) {
      bytes.push(((c >> 18) & 0x07) | 0xF0)
      bytes.push(((c >> 12) & 0x3F) | 0x80)
      bytes.push(((c >> 6) & 0x3F) | 0x80)
      bytes.push((c & 0x3F) | 0x80)
    } else if (c >= 0x000800 && c <= 0x00FFFF) {
      bytes.push(((c >> 12) & 0x0F) | 0xE0)
      bytes.push(((c >> 6) & 0x3F) | 0x80)
      bytes.push((c & 0x3F) | 0x80)
    } else if (c >= 0x000080 && c <= 0x0007FF) {
      bytes.push(((c >> 6) & 0x1F) | 0xC0)
      bytes.push((c & 0x3F) | 0x80)
    } else {
      bytes.push(c & 0xFF)
    }
  }
  var array = new Int8Array(bytes.length)
  for (let i = 0; i <= bytes.length; i++) {
    array[i] = bytes[i]
  }
  return array.buffer
}

export const encrypt = (o, salt) => {
  o = JSON.stringify(o).split('')
  for (var i = 0, l = o.length; i < l; i++) {
    if (o[i] === '{') { o[i] = '}' } else if (o[i] === '}') { o[i] = '{' }
  }
  return encodeURI(salt + o.join(''))
}

export const decrypt = (o, salt) => {
  o = decodeURI(o)
  if (salt && o.indexOf(salt) !== 0) { throw new Error('object cannot be decrypted') }
  o = o.substring(salt.length).split('')
  for (var i = 0, l = o.length; i < l; i++) {
    if (o[i] === '{') { o[i] = '}' } else if (o[i] === '}') { o[i] = '{' }
  }
  return JSON.parse(o.join(''))
}

// 根据url获取配置信息
export function getConfigFromUrl (url) {
  return new Promise((resolve, reject) => {
    try {
      // 下载配置添加token
      var result = null
      var blob = null
      var xhr = new XMLHttpRequest()
      xhr.open('GET', url)
      xhr.responseType = 'blob'
      // 加载时处理
      xhr.onload = () => {
      // 获取返回结果
        blob = xhr.response
        var reader = new FileReader()
        reader.readAsText(blob, 'utf-8')// 发起异步请求
        reader.onload = function () {
        // 返回结果
          result = JSON.parse(this.result)
          resolve(result)
        }
      }
      xhr.onerror = (e) => {
        reject(e)
      }
      // 发送
      xhr.send()
    } catch (e) {
      console.log(e)
    }
  })
}

// 根据数组获取用户信息列（明细-卡片模式使用）
import { getopenuserlist } from '@/port/clientSide/multipleChoice'

export const getUserLists = async (list = [], allDatas = []) => {
  if (!list || list.length === 0) return []
  let arr = []
  for (const i of list) {
    if (typeof i === 'object' && !Array.isArray(i)) {
      for (const a in i) {
        if (Array.isArray(i[a])) {
          const filterArr = allDatas.filter(item => item.name === a)
          // 如果用的是表单数据 就不用获取信息了 不存在卡片配置里面也不用查询了
          let isAdd = true
          if (filterArr.length > 0) {
            for (let index = 0; index < filterArr.length; index++) {
              const item = filterArr[index];
              const userKey = item.userKey || 'realname'
              console.log(userKey, 'filterArrfilterArrfilterArr')
              if (userKey.search('-data') !== -1) {
                isAdd = false
              } else {
                isAdd = true
                continue
              }
            }
          } else {
            isAdd = false
          } 
          if (isAdd) {
            for (const ii of i[a]) {
              if (ii.userId) arr.push(ii.userId)
            }
          }
        }
      }
    }
  }
  if (arr.length === 0) return list

  // 去重用户id
  arr = [...new Set(arr)]
  const { code, data } = await getopenuserlist({ userids: arr.join(','), curpage: 0, pagesize:1000 }).catch(err => { console.log(err) })
  if (code === 0) {
    const ob = {}
    const ars = []
    for (const i of data) {
      if (i.userId) ob[i.userId] = i
    }
    for (let i = 0; i < list.length; i++) {
      if (list[i] && typeof list[i] == 'object' && !Array.isArray(list[i])) {
        const obs = {}
        for (const a in list[i]) {
          const c = list[i][a]
          if (c && Array.isArray(c) && c.length> 0 && c[0].userId) {
            obs[a] = c.map(it => {
              return { ...it, ...ob[it.userId] }
            }).filter(it => it)
          }
        }
        ars.push(obs)
      } else {
        ars.push({})
      }
    }
    return ars
  }
  return []
}
